const BUDGET_TYPES = [
  { label: "Original Budget", value: "original" },
  { label: "Actual", value: "actual" },
  { label: "Budget Performance", value: "pi" },
  { label: "Revised", value: "revised" },
];

export { BUDGET_TYPES };
